import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import SectionHeader from '../SectionHeader';

import {RecordsSortContextProvider} from '/context/RecordsSort';

storiesOf('base', module).add('Section Header', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Section Header</Heading>
        <Spacer size={16} />
        <Text>
          This is the <Code>{'SectionHeader'}</Code> component. It is is used
          for list headers or section headers for <Code>{'FlatLists'}</Code> or{' '}
          <Code>{'SectionLists'}</Code>.
        </Text>
      </Spacing>
      <RecordsSortContextProvider>
        <SectionHeader isStoryBook={true}>Section Header</SectionHeader>
      </RecordsSortContextProvider>
    </FlexView>
  </ScrollView>
));
